import { motion, Variants } from 'framer-motion';
import { FC } from 'react';

export interface StepWrapperProps {
  visible: boolean;
}

export const variants: Variants = {
  visible: {
    opacity: 1,
    scale: 1,
    display: 'block',
    transition: { duration: 0.15, delay: 0.15 },
  },
  hidden: {
    opacity: 0,
    scale: 0.95,
    transition: { duration: 0.15 },
    transitionEnd: { display: 'none' },
  },
};

export const StepWrapper: FC<StepWrapperProps> = ({ children, visible }) => {
  return (
    <motion.section
      variants={variants}
      animate={visible ? 'visible' : 'hidden'}
      hidden={!visible}
    >
      {children}
    </motion.section>
  );
};
